import { render, staticRenderFns } from "./tavNav.vue?vue&type=template&id=cc05f65c&scoped=true"
import script from "./tavNav.vue?vue&type=script&lang=js"
export * from "./tavNav.vue?vue&type=script&lang=js"
import style0 from "./tavNav.vue?vue&type=style&index=0&id=cc05f65c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc05f65c",
  null
  
)

export default component.exports